import { Injectable } from '@angular/core';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { APP_SETTINGS } from '@mainrepo/app/core/constants/AppSettings';
import { SHARE_DC } from '@mainrepo/app/core/constants/ShareDCURLs';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class DcgroupcodePickerService {
  http: any;
  static singleInstance: any = null;
  localStorageService: any;

  constructor(public globalService:GlobalService) { 
    this.http = this.globalService.getHttpClientRef();
    this.localStorageService = this.globalService.getLocalStorageSvcRef();
  }

  public static getInstance(globalService):DcgroupcodePickerService{
    if(this.singleInstance == null){
      this.singleInstance = new DcgroupcodePickerService(globalService);
      return this.singleInstance;
    }else{
      return this.singleInstance;
    }
  }

  async decideTypeOfShare(shareKey){
    let type = window.location.href.includes("?u=") ? 'public' : 'private';
    let dcGroupCodeURL = ""
    if(type == 'public'){
      dcGroupCodeURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["getPublicShareDc"]  + shareKey;
      await this.fetchPublicShareDCCode(dcGroupCodeURL);
      return true;
    }else{
      dcGroupCodeURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["getPrivateShareDC"]  + shareKey;
      await this.fetchPrivateShareDCCode(dcGroupCodeURL);
      return true;
    }
  }

  
  fetchPublicShareDCCode(url){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
          async suc=>{
            await self.fetchShareMultiDcUrls(suc["shareDCCode"])
            resolve(suc["shareDCCode"])
          },
          async err=>{
            reject(err)
          }
      )
    })
  }

  fetchPrivateShareDCCode(dcGroupCodeURL){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(dcGroupCodeURL).subscribe(
          async suc=>{
            await self.fetchShareMultiDcUrls(suc["shareDCCode"])
            resolve(suc["shareDCCode"].toLowerCase())
          },
          async err=>{
            reject(err)
          }
      )
    })
  }

  updateShareDCInConstant(suc){
    SHARE_DC["DC_URLS"] = { ...SHARE_DC["DC_URLS"], ...suc}
    SHARE_DC["DC_URLS"]["ALBUMS_SMALL_FILE_UPLOAD"] = SHARE_DC["DC_URLS"]["boardUploadURL"] + ENV_CONFIG.commonUrls["singleFileUpload"];
    SHARE_DC["DC_URLS"]["SMALL_FILE_UPLOAD"] = SHARE_DC["DC_URLS"]["uploadURL"] + ENV_CONFIG.commonUrls["singleFileUpload"];
    SHARE_DC["DC_URLS"]["CHUNK_UPLOAD_INITIATE"] = SHARE_DC["DC_URLS"]["uploadURL"] + ENV_CONFIG.commonUrls["upload"],
    SHARE_DC["DC_URLS"]["CHUNK_UPLOAD"] = SHARE_DC["DC_URLS"]["uploadURL"] + ENV_CONFIG.commonUrls["chunkUpload"],
    SHARE_DC["DC_URLS"]["CREATE_FOLDER"] = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["createFolder"],
    SHARE_DC["DC_URLS"]["CREATE_PRIVATE_FOLDER"] = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["createPrivateFolder"]
  }

  async fetchShareMultiDcUrls(dcGroupCode){
    let dcURL = APP_SETTINGS["SETTINGS"]["dcUrls"].filter(function(dc){
        return dc.dcGroupCode.toLowerCase() == dcGroupCode.toLowerCase();
    });
    this.updateShareDCInConstant(dcURL[0])
  }

  updateEndpointBasedOnDCGroupCode(url,pickLoggedInDcGroupCode=false){
    let checkIfUrToBeIgnored = this.checkIfURLNeedsUpdate(url);
    if(checkIfUrToBeIgnored) return url;
    
    let dcCode = SHARE_DC["DC_URLS"]["dcGroupCode"];
    if(!dcCode || pickLoggedInDcGroupCode){
      dcCode = this.localStorageService.getDCGroupCode(true);
    }
    if(dcCode){
      url = "/" + dcCode.toLowerCase() + url
    }
    return url;
  }

  getShareDCGroupCode(){
    let dcCode = SHARE_DC["DC_URLS"]["dcGroupCode"];
    return dcCode;
  }


  checkIfURLNeedsUpdate(url){
    let updateRequired = SHARE_DC["URLS_TO_IGNORE_UPDATING_DCCODE"].some(function (ignrStrng) {
      if (url.includes(ignrStrng)) {
        return true;
      }
    });

    return updateRequired;
  }
}
